import React from 'react';
import PropTypes from 'prop-types';
import { FooterWrapper } from '../../style';
import { checkCSRBusinessFunction } from '../../../../../../CSR/utils/CommonUtils';
import { BUSINESS_FUNCTION } from '../../../../../../CSR/utils/csrBusinessFunctionMapper';
import {
  CapsuleButton,
  GeneralButton,
} from '../../../../../../CommonComponents/Commons/commonComponents';

const RecurringFooter = (props) => (
  <FooterWrapper Main>
    {props.role !== 'Read Only' &&
      (checkCSRBusinessFunction(
        BUSINESS_FUNCTION[
          'DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS'
        ],
        props.csrBusinessFunction
      ) ? (
        <CapsuleButton text="Add Grant" iconType="add" disabled={true} alt = "add icon"/>
      ) : (
        <CapsuleButton
          text="Add Grant"
          onClick={props.addGrandHandler}
          iconType="add"
          alt = "add icon"
        />
      ))}
    {
      <FooterWrapper Button leftAlign={props.role === 'Read Only'}>
        {props.cancelPaymentFlag ? (
          props.paymentFlag ? (
            <GeneralButton
              text="Show all payments"
              type="tertiary"
              onClick={props.showPaymentHandle}
              id="btnShowallpayments"
            />
          ) : (
            <GeneralButton
              text="Hide all completed payments"
              type="tertiary"
              onClick={props.hidePaymentHandle}
              id="btnHideallcompletedpayments"
            />
          )
        ) : (
          ''
        )}
        {props.cancelPaymentFlag && props.role !== 'Read Only' && (
          <GeneralButton
            text="Cancel all remaining payments"
            disabled={checkCSRBusinessFunction(
              BUSINESS_FUNCTION[
                'DONOR_PORTAL_EDIT_RECURRING_GRANT_SCHEDULE_FULL_ACCESS'
              ],
              props.csrBusinessFunction
            )}
            type="tertiary"
            onClick={props.cancelPaymentHandle}
            id="btnCancelallremainingpayments"
          />
        )}
      </FooterWrapper>
    }
  </FooterWrapper>
);

RecurringFooter.propTypes = {
  addGrandHandler: PropTypes.func,
  cancelPaymentFlag: PropTypes.bool,
  cancelPaymentHandle: PropTypes.func,
  csrBusinessFunction: PropTypes.any,
  hidePaymentHandle: PropTypes.func,
  paymentFlag: PropTypes.bool,
  role: PropTypes.string,
  showPaymentHandle: PropTypes.func,
};

export default RecurringFooter;
